// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"RoomDetails_buttonContainer__1t-YB"};